
import axios from 'axios';
import FormData from 'form-data';
import dashboard from 'menu-items/dashboard';

//Esta es la librería que se usa para hacer y recibir todas las peticiones post y get al API
export default class WebApi  {
    //si desea consultar solo dashboard categoria.json?dashboard=true
    //todas las url y direcciones de la API
    SHOW_ALERT= true;
    EXPO_PUBLIC_X_API_KEY = "";
    _BASE_URL= "";
    _IMAGES_URL="https://api.afiservicios.com/";

    // API APP 
    SETTING= 'setting.json';
    USUARIO= 'user.json';


    USER_LOGIN='admin_login.json';
    USUARIO_CREAR='usuario_crear.json';
    USUARIOS='usuarios.json';
    USUARIO_PERFIL_UPDATE='usuario_perfil_update.json';
    PROFESIONALES='usuarios_profesionales.json';
    ELIMINADOS='usuarios_eliminados.json';
    PUBLICACIONES='publicaciones.json';
    REPORTADOS='reportados.json';
    USUARIO_DELETE='usuario_delete.json';
    HACER_ADMIN='usuario_toAdmin.json';
    CATEGORIAS='categoria.json';
    POR_CATEGORIAS='porCategoria.json';
    POR_CATEGORIAS_DESGLOSE='porCategoriaDesglose.json';
    CATEGORIA='categoria.json';
    CATEGORIA_NUEVA='categoria_nueva.json';
    CATEGORIA_DELETE='categoria_delete.json';
    STATS = 'stats.json';
    GENERAL_DATA='generalData.json';
    GENERAL_TOTAL_SEXO='generalTotalsSexo.json';
    POSTS_UPDATE_STATUS='reportadosActualizar.json';
    SERVICIOS_AFI='servicios_afi.json';
    SERVICIOS_AFI_UPDATE='servicios_afi_update.json';
    SERVICIOS_AFI_UPDATE_STATUS='servicios_afi_update_status.json';
    NOTIFICATION_SEND='sendNotification.json';
    TASK='tareas.json';

      constructor() {
        this._BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.example.com/'; // Use env variable or fallback
        this.EXPO_PUBLIC_X_API_KEY = process.env.EXPO_PUBLIC_X_API_KEY; // Configurable alert flag
      }
    
      // Utility to check online status
      #checkOnlineStatus() {
        if (!navigator.onLine) {
          const error = {
            no_result: true,
            error: 'No hay conexión a internet',
          };
          if (this.SHOW_ALERT) {
            setTimeout(() => alert(error.error), 400);
          }
          return error;
        }
        return null;
      }
    
      // Utility to construct URL
      #constructUrl(url, external = false) {
        return external ? url : `${this._BASE_URL}${url}`;
      }
    
      // Generic request handler
      async #sendRequest({ method, url, data = null, headers = { 'Content-Type': 'application/x-www-form-urlencoded', 'X-API-KEY':  this.EXPO_PUBLIC_X_API_KEY  }, timeout = 15000 }) {
        const offlineError = this.#checkOnlineStatus();
        if (offlineError) return offlineError;
    
        const fullUrl = this.#constructUrl(url);
       // console.log(`API ${method.toUpperCase()} _url`, fullUrl);
    
        try {
          const config = {
            method,
            url: fullUrl,
            headers,
            timeout,
          };
    
          if (data) {
            config[method === 'get' ? 'params' : 'data'] = data;
          }
    
          const response = await axios(config);
       //   console.log(`API ${method.toUpperCase()} response`, response);
          return response;
        } catch (error) {
          const err = {
            no_result: true,
            error: error.message || 'Error en la solicitud',
          };
          console.error(`Error on ${method.toUpperCase()} ${fullUrl}`, err);
          if (this.SHOW_ALERT) {
            setTimeout(() => alert('No se han encontrado resultados'), 400);
          }
          return err;
        }
      }
    
      // GET request
      async sendGetRequest(url, params = null, external = false) {
        return this.#sendRequest({
          method: 'get',
          url,
          data: params,
        });
      }
    
      // POST request
      async sendPostRequest(url, params = {}) {
        return this.#sendRequest({
          method: 'post',
          url,
          data: params,
        });
      }
    
      // PUT request
      async sendPutRequest(url, params = {}) {
        return this.#sendRequest({
          method: 'put',
          url,
          data: params,
        });
      }
    
      // DELETE request
      async sendDeleteRequest(url, params = null) {
        return this.#sendRequest({
          method: 'delete',
          url,
          data: params,
        });
      }
    
      // POST file request
      async sendPostFileRequest(url, params = {}, file) {
        const offlineError = this.#checkOnlineStatus();
        if (offlineError) return offlineError;
    
        if (!file) {
          const err = {
            no_result: true,
            error: 'No se proporcionó ningún archivo',
          };
          console.error('No file provided', err);
          return err;
        }
    
        const fullUrl = this.#constructUrl(url);
        console.log('API FILE _url', fullUrl);
    
        const formData = new FormData();
        formData.append('file', file);
    
        for (const [key, value] of Object.entries(params)) {
          formData.append(key, value);
        }
    
        return this.#sendRequest({
          method: 'post',
          url,
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-API-KEY': this.EXPO_PUBLIC_X_API_KEY,
          },
        });
      }

    // API methods versionamiento
    getCiudades(){
      let url = this.SETTING + `?action=ciudad&status=A&getAll=true`;
      return this.sendGetRequest(url);
    }

    getAllCategorias(search, page){
      let url = this.CATEGORIAS + `?action=get&status=A&getAll=true&pag=${page}`;
      if(search !== ''){
        url += `&search=${search}`;
      }
      
      return this.sendGetRequest(url);
    }

    deleteUserForever(_id,_email, ejecutor) {
      let url = this.USUARIO + `?action=eliminar_cuenta&id=${_id}&email=${_email}&pass=rZwJu8kOP8kfqnd&tipo=ADMIN&ejecutor=${ejecutor}`;
      return this.sendGetRequest(url)
    }


    getReportesPrincipal(){
      let url = this.STATS;
      return this.sendGetRequest(url);
    }


    /** ejemplo
      // Category-specific methods (assuming these are part of WebApi)
      async getAllCategorias(search = '', page = 1) {
        return this.sendGetRequest('/categorias', { search, page });
      }
    
      async updateCategoria(id, nombre, icono = '') {
        return this.sendPutRequest(`/categorias/${id}`, { nombre, icono });
      }
    
      async deleteCategoria(id) {
        return this.sendDeleteRequest(`/categorias/${id}`);
      }
    
      
     */


    // DASHBOARD
    getReportados(search,pag){
      let url= this.REPORTADOS +
          `?dashboard=true&search=${search}&pag=${pag}`;
          return this.sendGetRequest(url);
    }

    getLogs(search,pag){
      let url= 'logs.json' +
          `?dashboard=true&search=${search}&pag=${pag}`;
          return this.sendGetRequest(url);
    }

    getTareas(search,pag){
      let url= this.TASK +
          `?dashboard=true&search=${search}&pag=${pag}`;
          return this.sendGetRequest(url);
    }

    setCheckedTask(id) {
      let url = this.TASK + `?dashboard=true`;
      let _params = `id=${id}`;
      return this.sendPostRequest(url, _params);
    }

    getPublicaciones(search,pag){
      let url= this.PUBLICACIONES +
          `?dashboard=true&search=${search}&pag=${pag}`;
          return this.sendGetRequest(url);
    }

    postUpdateStatus(id, action, ejecutor){ //id de reportado
      let url = this.POSTS_UPDATE_STATUS+`?dashboard=true&id=${id}&action=${action}&ejecutor=${ejecutor}`;
      return this.sendGetRequest(url);
    }

    userCreate(nombre, apellido, email, password){
      let url= this.USUARIO_CREAR + `?dashboard=true&nombre=${nombre}&apellido=${apellido}&email=${email}&password=${password}`;
      return this.sendGetRequest(url);
    }

    userLogin(_email, _password) {
        let url = this.USER_LOGIN + "?dashboard=true";
        let params = `email=${_email}&pass=${_password}`;
        return this.sendPostRequest(url, params);
    }

    getUsers(search, pag, permiso=false) {
        let url = this.USUARIOS + `?dashboard=true&pag=${pag}&permiso=${permiso}&search=${search}`;
        return this.sendGetRequest(url);
    }

    getUser(id) {
      let url = this.USUARIOS + `?dashboard=true&usuario=${id}`;
      return this.sendGetRequest(url);
    }

    updateUsuarioAfi( values, file){
      let url = this.USUARIO_PERFIL_UPDATE+ `?dashboard=true`;
      let params = `id=${values.id}&nombre=${values.nombre}&apellido=${values.apellido}`
                    + `&telefono=${values.telefono}&email=${values.email}`
                    + `&direccion=${values.direccion}&ruc=${values.ruc}`;
      if(typeof file === 'undefined' || !file || file.length === 0){
        return this.sendPostRequest(url, params);
      }
      //console.log(file)
      return this.sendPostFileRequest(url,values, file);
    }


    getProfesionales(search, pag, permiso){
      let url = this.PROFESIONALES + `?dashboard=true&search=${search}&pag=${pag}&permiso=${permiso}`;
      return this.sendGetRequest(url);
    }

    getEliminados(search, pag, permiso){
      let url = this.ELIMINADOS + `?dashboard=true&search=${search}&pag=${pag}&permiso=${permiso}`;
      return this.sendGetRequest(url);
    }

    getServiciosAfi(search, pag, permiso){
      let url = this.SERVICIOS_AFI + `?dashboard=true&search=${search}&pag=${pag}`;
      return this.sendGetRequest(url);
    }

    updateServiciosAfi( values, file){
      let url = this.SERVICIOS_AFI_UPDATE+ `?dashboard=true`;
      let params = `id=${values.id}&nombre=${values.nombre}&apellido=${values.apellido}`
                    + `&telefono=${values.telefono}&email=${values.email}&tipo=${values.tipo}`
                    + `&direccion=${values.direccion}&cedula=${values.cedula}`;
      if(typeof file === 'undefined' || !file || file.length === 0){
        return this.sendPostRequest(url, params);
      }
      //console.log(file)
      return this.sendPostFileRequest(url,values, file);
    }

    updateServiciosAfiStatus(id, estado){
        let url = this.SERVICIOS_AFI_UPDATE_STATUS + `?dashboard=true&user_id=${id}&estado=${estado}`;
        return this.sendGetRequest(url);
    }
    //BUSCAR CLIENTES PARA  AUTOCOMPLETE
 
    getData(){
      let url = this.GENERAL_DATA + `?dashboard=true`;
      return this.sendGetRequest(url);
    }
    getTotalSexo(){

      let url = this.GENERAL_TOTAL_SEXO + `?dashboard=true`;
      return this.sendGetRequest(url);
    }

    updateStatus(id, estado, ejecutor){
      let url = this.USUARIO_DELETE + `?dashboard=true&user_id=${id}&estado=${estado}&ejecutor=${ejecutor}`;
        return this.sendGetRequest(url);
    }

    deleteUser(id, estado, ejecutor){
        let url = this.USUARIO_DELETE + `?dashboard=true&user_id=${id}&estado=${estado}&delete=true&ejecutor=${ejecutor}`;
        return this.sendGetRequest(url);
    }



  hacerAdmin(id, ejecutor){
    let url = this.HACER_ADMIN + `?dashboard=true&user_id=${id}&ejecutor=${ejecutor}`;
    return this.sendGetRequest(url);
  }

    getReportePorCategorias(){
      let url = this.POR_CATEGORIAS + `?dashboard=true&status=A&getAll=true`;
      return this.sendGetRequest(url);
    }

    getProfesionalesDesglose(search, pag, permiso, categoria){
      let url = this.POR_CATEGORIAS_DESGLOSE + `?dashboard=true&search=${search}&pag=${pag}&permiso=${permiso}&categoria=${categoria}`;
      return this.sendGetRequest(url);
    }

    sendNotification(id, mensaje){
      let url= this.NOTIFICATION_SEND+`?dashboard=true&id=${id}&mensaje=${mensaje}` ;
      return this.sendGetRequest(url);

    }

    updateCategoria(id, nombre,icono){
      let url = this.CATEGORIA + '?dashboard=true';
      let _params = `id=${id}&nombre=${nombre}&icono=${icono}`;
      return this.sendPostRequest(url,_params);
    }

    deleteCategoria(id){
      let url = this.CATEGORIA+ '?dashboard=true';
      let _params = `id=${id}`;
      return this.sendDeleteRequest(url,_params);
    }

    async uploadFileCategory(id, file) {
      return this.sendPostFileRequest( this.CATEGORIA, { id: id, action: 'upload', dashboard : true }, file);
    }

    descodificarEntidad(str) {
        return str.replace(/&#(\d+);/g, function(match, dec) {
          return String.fromCharCode(dec);
        });
    }

}
